import { useMemo } from 'react';
import { useStoreName } from 'domains/Auth/hooks';
import { useGetDomainSuggestionsQuery } from '../domainsApi';

const sanitizeDomainName = (name: string): string => {
  if (!name) return '';

  return name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 63)
    .replace(/-+$/g, '');
};

export function useDomainSuggestionByName() {
  const storeName = useStoreName();

  const sanitizedStoreName = useMemo(
    () => sanitizeDomainName(storeName),
    [storeName],
  );

  const {
    data: { recommendation, suggestions } = {},
    isLoading,
    error,
  } = useGetDomainSuggestionsQuery(
    { query: sanitizedStoreName },
    { skip: !sanitizedStoreName },
  );

  return {
    recommendation,
    suggestions,
    isLoading,
    error,
    storeName: sanitizedStoreName,
  };
}
